import { FlagsImplementationProvider, Route } from '@atlassian/mpac-ui';
import { UrlUtils } from '@atlassian/mpac-utils';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Switch } from 'react-router';
import { addFlag, removeFlag } from '../../../actions/Flags';
import { manageAppRequestsRoute, managePromotionsRoute, manageRoute } from '../../../constants/Routes';
import { makeEmceeFlag } from '../../../records/Flag';
import { getCloudIdFromHostInfo } from '../../../services/HostInfoApi';
import { useMountPath } from '../../AppContext';
import ManageAppRequests from './ManageAppRequests';
import ManageAppsRoutes from './ManageAppsRoutes';
import ManagePromotions from './ManagePromotions';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ManageRoutes = props => {
  const mountPath = useMountPath();
  const dispatch = useDispatch();
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      exact: true,
      path: UrlUtils.joinPathNames([mountPath, manageRoute.path]),
      render: routeProps => /*#__PURE__*/_jsx(ManageAppsRoutes, {
        bootstrapConfig: props.bootstrapConfig,
        currentUserId: props.currentUserId,
        history: routeProps.history,
        hostConfig: props.hostConfig,
        links: props.links,
        onRendered: props.onRendered,
        selectedContext: props.selectedContext,
        mountPath: mountPath
      })
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: UrlUtils.joinPathNames([mountPath, manageAppRequestsRoute.path]),
      render: routeProps => /*#__PURE__*/_jsx(FlagsImplementationProvider, {
        value: {
          showFlag: flag => dispatch(addFlag({
            flag: makeEmceeFlag(flag)
          })),
          dismissFlag: key => dispatch(removeFlag(key))
        },
        children: /*#__PURE__*/_jsx(ManageAppRequests, {
          bootstrapConfig: props.bootstrapConfig,
          algoliaClient: props.algoliaClient,
          currentUserId: props.currentUserId,
          history: routeProps.history,
          location: routeProps.location,
          hostInfo: props.hostInfo,
          onRendered: props.onRendered
        })
      })
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: UrlUtils.joinPathNames([mountPath, managePromotionsRoute.path]),
      render: routeProps => {
        var _getCloudIdFromHostIn;
        return (
          /*#__PURE__*/
          _jsx(ManagePromotions, {
            productName: props.hostInfo.product,
            cloudId: (_getCloudIdFromHostIn = getCloudIdFromHostInfo(props.hostInfo)) !== null && _getCloudIdFromHostIn !== void 0 ? _getCloudIdFromHostIn : '',
            links: props.links,
            history: routeProps.history,
            hostPricing: props.hostPricing
          })
        );
      }
    })]
  });
};
export default ManageRoutes;